import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'

export default function useLocationAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const userData = store.state?.userStore?.userData
  const location = ref({ dailyDialoguesCount: 1, dailyDialogueDays: [1, 2, 3, 4, 5, 6, 0] })
  const isSubmitting = ref(false)
  const collection = 'location'

  const create = async (data) => {
    isSubmitting.value = true

    const payload = {
      client_id: oid(userData.client.$oid),
      area: data.area?.value ?  oid(data.area?.value)  : null,
      physical_location: data.physical_location?.value ? oid(data.physical_location.value) : null,
      departmentLeads: data.departmentLeads?.value ? data.departmentLeads?.value.map(e => oid(e)) : [],
      dailyDialoguesCount: data.dailyDialoguesCount?.value,
    }

    if (data.location?.value) payload.location = data.location.value
    if (data.zone?.value) payload.zone = data.zone.value
    if (data.agency?.value) payload.agency = data.agency.value
    if (data.dailyDialogueDays?.value) payload.dailyDialogueDays = data.dailyDialogueDays.value

    try {
      await createItem({ collection, payload })
      showSuccessMessage(i18n.t('message.location_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.location_add_error'))
    } finally {
      router.push({ name: 'organization-location-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    location,
    isSubmitting,
  }
}
